import { Block, useHttpCommand } from '@esg/ui';
import './Home.scss';
import { useEffect } from 'react';
import { getEnv } from '@esg/shared';
import { getForwardTokenReview } from '@esg/business-client-review';
import { Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

export function Forward() {
  const { saleId } = useParams();
  const navigate = useNavigate();

  const headerRequest: Record<string, string> = {
    Authorization: `Basic ${btoa(`${getEnv().USER_BASIC_AUTH}:${getEnv().PASSWORD_BASIC_AUTH}`)}`,
  };

  const { mutateAsync: getTokenReview } = useHttpCommand(getForwardTokenReview);

  useEffect(() => {

    const fetchGetToken = async () => {
      try {
        const fetchGetCheckReview = async () => {
          const tokenReview = await getTokenReview({
            pathData: {
              saleId: saleId
            },
            header: headerRequest,
          });

          if (tokenReview?.endPoint) {
            navigate(`/${tokenReview?.endPoint}`, { replace: true });
          }
        };
        fetchGetCheckReview();
      } catch (error) {
        console.error("Error fetching token sale:", error);
      }
    };
    fetchGetToken();

  }, [saleId]);

  return (
    <Spin spinning>
      <Block className='home-custom'>
      </Block >
    </Spin>
  );
}
